<template>
  <div>
    <v-snackbar
      value="true"
      timeout="-1"
      centered
      shaped
      :color="color"
      :icon="icon"
      border="left"
      prominent
      width="650"
    >
      <v-row>
        <v-col cols="1" class="mt-4">
          <v-icon x-large>{{ icon }}</v-icon></v-col
        >
        <v-col cols="">
          <p class="pa-2">
            {{ message }}
          </p></v-col
        >
        <v-col cols="3">
          <v-btn color="accent" class="mb-2" @click="confirm">Yes</v-btn>
          <v-btn color="" @click="cancel">Cancel</v-btn>
        </v-col>
      </v-row>
    </v-snackbar>
  </div>
</template>

<script>
// import { mapActions } from "vuex";
export default {
  props: ["type", "message", "will_confirm", "color", "icon"],
  data() {
    return {};
  },
  created() {},
  methods: {
    confirm() {
      this.$emit("confirm-event");
    },
    cancel() {
      this.$emit("cancel-event");
    },
  },
};
</script>

<style scoped></style>
